import {Font} from "./Font";

/**
 *
 * Created by jlado on 25/8/16.
 */
export const FONTS_LIST = [
    new Font("Arial", "Arial"),
    new Font("Arial Black", "Arial Black"),
    new Font("Comic Sans MS", "Comic Sans MS"),
    new Font("Courier New", "Courier New"),
    new Font("Georgia", "Georgia"),
    new Font("Impact", "Impact"),
    new Font("Times New Roman", "Times New Roman"),
    new Font("Trebuchet MS", "Trebuchet MS"),
    new Font("Verdana", "Verdana"),
];
export const BLACK_COLOR = "#000000";
export const SERVILEASING_COLOR = "#31708f";


/** WEBPACK FOOTER **
 ** ./src/app/common/common.ts
 **/